import client from './client';

// 导入导出权限 / 服务端导出（2026-10-06）：策略与额度由服务端权威计算（强校验同源）

export interface BackupPolicyView {
  tier: 'superadmin' | 'paid' | 'free';
  /** ZIP 打包备份是否可见可用（默认仅超级管理员） */
  zipAllowed: boolean;
  json: {
    allowed: boolean;
    /** 每月额度：-1 = 不限 */
    quota: number;
    used: number;
    /** -1 = 不限 */
    remaining: number;
  };
}

export async function fetchBackupPolicy(): Promise<BackupPolicyView> {
  const { data } = await client.get('/backup/policy');
  return (data?.data ?? data) as BackupPolicyView;
}

export interface BackupFileResult {
  blob: Blob;
  filename: string;
  itemCount: number;
}

/** 服务端权威导出（json 元数据 / zip 打包；zip 仅超管，服务端 403/429 由调用方统一处理） */
export async function downloadBackupFile(
  kind: 'scenes' | 'pages',
  mode: 'json' | 'zip',
  id?: string,
): Promise<BackupFileResult> {
  const res = await client.get(`/backup/${kind}/file`, {
    params: { mode, ...(id ? { id } : {}) },
    responseType: 'blob',
  });
  const headers = (res.headers || {}) as Record<string, string>;
  const cd = String(headers['content-disposition'] || headers['Content-Disposition'] || '');
  const nameMatch = cd.match(/filename="?([^";]+)"?/);
  const fallback = `dtwin-${kind}-${new Date().toISOString().slice(0, 10)}.${mode}`;
  return {
    blob: res.data as Blob,
    filename: nameMatch?.[1] || fallback,
    itemCount: Number(headers['x-export-count'] || headers['X-Export-Count'] || 0),
  };
}

/** 解析 axios blob 错误体（服务端 { code, message, statusCode }） */
export async function parseBackupError(e: unknown): Promise<{ code?: string; message?: string; status?: number }> {
  const err = e as any;
  const status = err?.response?.status;
  let data = err?.response?.data;
  if (data && typeof Blob !== 'undefined' && data instanceof Blob) {
    try {
      data = JSON.parse(await data.text());
    } catch {
      data = null;
    }
  }
  return {
    code: data?.code,
    message: data?.message || err?.message,
    status,
  };
}
